import type { Guide } from '@guideguide/shared/src/lib/guide'
import { atom } from 'nanostores'

export interface Fauxtoshop {
  guidesAreVisible: boolean
  guides: Guide[]
  document: { width: number; height: number } | null
  selection: {
    x: number
    y: number
    height: number
    width: number
    animate: boolean
  } | null
  isBroken: boolean
  postBreakClicks: number
}

export const fauxtoshopStore = atom<Fauxtoshop>({
  guidesAreVisible: true,
  guides: [],
  document: null,
  selection: null,
  isBroken: false,
  postBreakClicks: 0,
})
